import { InputNumber, InputNumberProps } from "antd";
import { FC, KeyboardEvent } from "react";

type PureNumberInputProps = InputNumberProps;

const PureNumberInput: FC<PureNumberInputProps> = ({ onKeyDown, controls = false, ...props }) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
      const isDigit = /[0-9]/.test(e.key);
      const isNewDecimalPoint = e.key === "." && !e.currentTarget.value.includes(".");
      if (!isDigit && !isNewDecimalPoint) e.preventDefault();
    }
    onKeyDown?.(e);
  };

  return <InputNumber inputMode="decimal" controls={controls} onKeyDown={handleKeyDown} {...props} />;
};

export default PureNumberInput;
